import { Empty, List, Tag } from "antd";
import { useEffect, useMemo, useState } from "react";
import bin_img from "../../../assets/dashboard/bin_img.png";
import { useNavigate } from "react-router";

const normalize = (value) => String(value || "").trim().toLowerCase();

const isGsmBin = (bin) => normalize(bin?.bin_location) === "garment_super_market";
const isFullBin = (bin) => normalize(bin?.bin_full) === "yes";

const GSMDashboard = ({ userdata, gsmBins = [], loading = false }) => {
  const [displayBin, setDisplayBin] = useState([]);
  const [filteredBins, setFilteredBins] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const filtered = gsmBins.filter((bin) => isGsmBin(bin) && isFullBin(bin));
    setDisplayBin(filtered);
  }, [gsmBins]);

  const handleCardClick = (bin) => {
    navigate(`/gsm-bin-view?binId=${encodeURIComponent(bin.bin_id)}`);
  };

  const binsToDisplay = useMemo(() => {
    return filteredBins || displayBin;
  }, [filteredBins, displayBin]);

  if (loading) {
    return <div className="dashboard-loading-wrap" />;
  }

  return (
    <div className="dashboard-card-grid">
      {binsToDisplay.length > 0 ? (
        <List
          grid={{
            gutter: 16,
            xs: 1,
            sm: 2,
            md: 3,
            lg: 4,
            xl: 5,
          }}
          dataSource={binsToDisplay}
          renderItem={(bin) => (
            <List.Item>
              <div className="bin-card" onClick={() => handleCardClick(bin)}>
                <div className="bin-card-top">
                  <Tag
                    className="location-badge"
                    style={{
                      background: "#fce7f3",
                      color: "#9d174d",
                      borderColor: "#f9a8d4",
                      margin: 0,
                    }}
                  >
                    In GSM
                  </Tag>
                </div>

                <div className="bin-card-image-wrap">
                  <img src={bin_img} alt="bin" className="bin-card-image" />
                  <div className="bin-card-name">{bin.bin_name}</div>
                </div>

                <div className="bin-card-footer">
                  <div
                    className={`pcs-badge ${
                      isFullBin(bin) ? "full-badge" : "empty-badge"
                    }`}
                  >
                    {bin.total_quantity || 0} Pcs
                  </div>
                </div>
              </div>
            </List.Item>
          )}
        />
      ) : (
        <Empty description="No bins found for the GSM location(s)" />
      )}
    </div>
  );
};

export default GSMDashboard;